const promotion = {
    path: 'promotion',
    component: resolve => require(['@/pages/admin/trading/promotion'], resolve)
}

export default promotion
